import moment from 'moment';
import { useRecoilValue } from 'recoil';

import { useTranslation } from "src/hooks/translation";
import Radio from "src/common/components/radio";
import Money from "src/common/components/money";
import upperDataStore from 'src/stores/upperData';
import { useFreeBets } from "src/hooks/freeBets";

import './style.scss';
import InfoIcon from 'src/common/components/infoIcon';

const FreeBets = () => {
  const t = useTranslation();
  const [freeBets, toggleFreeBet, loading] = useFreeBets();
  const { freeBonuses } = useRecoilValue(upperDataStore);

  if (!freeBets.length || loading) return null;

  return (
    <div className="B-betslip-free-bets">
      {freeBets.map((freeBet) => {
        const freeBonus = freeBonuses.find((bonus) => bonus.id === freeBet.details.id);

        return (
          <label
            key={freeBet.details.id}
            className={`B-free-bet ${freeBet.disabled ? 'B-free-bet-disabled' : ''}`}
          >
            <Radio checked={freeBet.selected} onChange={() => !freeBet.disabled && toggleFreeBet(freeBet)} />

            <p className="B-content">
              <Money amount={freeBet.details.amount} /> - {t('EXPIRATION {1}', moment(freeBet.details.expiration_date).format('DD.MM.yy'))}
            </p>

            {freeBonus && <InfoIcon>
              <div className="B-betslip-free-bet-info">
                <i className="global-icon icon-warning-transparent" />
                <p>{freeBonus.description}</p>
              </div>
            </InfoIcon>}
          </label>
        )
      })}
    </div>
  )
}

export default FreeBets;